import env from 'helpers/env'

export const createProjectUrl = (providerId?: string) => {
  const nexusBasePath = '/projects/new'
  const path = providerId ? `${nexusBasePath}?legacy_provider_id=${providerId}` : nexusBasePath

  return nexusUrl(path)
}

export const editProjectUrl = (nexusProjectId: string) => (
  nexusUrl(`/projects/${nexusProjectId}/edit/`)
)

export const nexusCompareOffersEmbededUrl = (nexusProjectId: string) => (
  nexusUrl(`/projects/${nexusProjectId}/offers/compare/embed`)
)

export const nexusCompareOffersUrl = (nexusProjectId: string) => (
  nexusUrl(`/projects/${nexusProjectId}/offers/compare`)
)

export const nexusEditRequestPlanUrl = (nexusProjectId: string, ticketNumber: string) => (
  nexusUrl(`/projects/${nexusProjectId}/contracts/${ticketNumberToNexusPublicId(ticketNumber)}/plan/edit/`)
)

const nexusUrl = (path: string) => (
  nexusRoot() + 'legacy_login?redirect_to=' + encodeURIComponent(path)
)

const nexusRoot = () => (
  env.NEXUS_ROOT || 'https://www.eventinc.com/'
)

export const makeOfferUrl = (ticketNumber: string) => (
  nexusUrl(`/partner-dashboard/contracts/${ticketNumberToNexusPublicId(ticketNumber)}/offer/`)
)

const ticketNumberToNexusPublicId = (ticketNumber: string) => 'LGC_' + ticketNumber
